import { useEffect, useRef } from "react";

interface PdfViewerProps {
  url: string;
  title: string;
  onClose: () => void;
}

export default function PdfViewer({ url, title, onClose }: PdfViewerProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      ref={containerRef}
      className="fixed inset-0 z-[100] bg-godoy-black/95 backdrop-blur-sm flex flex-col"
    >
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-godoy-gray/30 bg-godoy-charcoal/80">
        <div className="flex items-center gap-3 min-w-0">
          <i className="ri-file-pdf-line text-xl text-godoy-gold flex-shrink-0" />
          <h2 className="text-godoy-cream font-medium text-sm md:text-base truncate">
            {title}
          </h2>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <a
            href={url}
            download
            className="hidden sm:flex items-center gap-2 px-4 py-2 bg-godoy-gold/10 border border-godoy-gold/40 rounded-md text-sm text-godoy-gold hover:bg-godoy-gold/20 transition-all"
          >
            <i className="ri-download-line" />
            Baixar
          </a>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-md bg-godoy-gray/30 text-godoy-cream hover:bg-red-500/20 hover:text-red-400 transition-all"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>
      </div>

      {/* PDF iframe */}
      <div className="flex-1 overflow-hidden">
        <iframe
          src={`${url}#toolbar=1&navpanes=0`}
          title={title}
          className="w-full h-full border-0"
        />
      </div>
    </div>
  );
}